import { useBreakpointValue, Utils } from '@genial/utils';
import React from 'react';

import { TermActionBaseProps, TermActionContent } from '../shared/TermAction/types';

import { TermAcceptanceDesktop } from './desktop';
import { TermAcceptanceMobile } from './mobile';

export const TermAcceptance: React.FC<TermActionBaseProps> = (props) => {
  const content: TermActionContent = {
    title: 'Termo de adesão',
    serviceName: 'Adesão ao modelo de remuneração via FEE FIXO',
    observation:
      'Após o aceite, haverá um período de permanência de 30 dias para encerramento ou substituição do modelo.',
    headerInfoItems: [
      { label: 'Assessor', value: props.termData?.advisorName || '--' },
      { label: 'Válido até', value: props.termData?.expirationDate || '--' },
    ],
    detailsInfoItems: [
      { label: 'Tipo', value: 'Contratação' },
      { label: 'Taxa sugerida', value: props.termData?.feeRate || '--' },
      {
        label: 'Início após aceite',
        value: Utils.Mask.DateFormat(new Date(), 'dd/MM/yyyy'),
      },
    ],
    refuseButtonLabel: 'Recusar',
    acceptButtonLabel: 'Aceitar',
    documentTitle: 'Termo de adesão',
  };

  const responsiveContainer = useBreakpointValue({
    base: <TermAcceptanceMobile {...props} content={content} />,
    sm: <TermAcceptanceDesktop {...props} content={content} />,
  });

  return responsiveContainer;
};
